export enum StationStatusEnum {
  ACTIVE = "ACTIVE",
  PENDING_CREATION = "PENDING_CREATION",
  PENDING_UPDATE = "PENDING_UPDATE",
  PENDING_CLOSURE = "PENDING_CLOSURE",
  OPENING_SOON = "OPENING_SOON",
  TEMPORARY_CLOSED = "TEMPORARY_CLOSED",
}
